module.exports = __webpack_public_path__ + "img/boolflix.072ad788.gif";